<template>
  <form class="auth-step" @submit.prevent="handleSubmit">
    <h4 class="mb-3">Sign in</h4>

    <div v-if="signupSuccessMessage" class="alert alert-success py-2 mb-20">
      Account created successfully! Please log in.
    </div>

    <div class="form-inner two mb-20">
      <label>Mobile No.</label>
      <div class="mobile-input-row">
        <span class="mobile-prefix">+91</span>
        <input
          :value="mobileDigits"
          type="tel"
          placeholder="Enter mobile number"
          autocomplete="tel"
          maxlength="10"
          @input="onMobileInput"
        >
      </div>
    </div>

    <div class="form-inner two mb-10">
      <label>Password</label>
      <div class="password-wrapper">
        <input
          :value="password"
          :type="showPassword ? 'text' : 'password'"
          placeholder="Enter password"
          autocomplete="current-password"
          @input="onPasswordInput"
        >
        <button type="button" class="password-toggle" @click="showPassword = !showPassword">
          <i :class="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
        </button>
      </div>
    </div>

    <div class="text-end mb-20">
      <a href="#" class="small" @click.prevent="$emit('forgot-password')">Forgot Password?</a>
    </div>

    <button type="submit" class="primary-btn1 w-100 mb-20" :disabled="busy">
      <span>{{ busy ? 'Logging in...' : 'Log in' }}</span>
    </button>

    <div class="text-center mb-10">or</div>

    <button type="button" class="primary-btn1 black-bg w-100" @click="$emit('switch-mode')">
      <span>Sign up</span>
    </button>
  </form>
</template>

<script setup>
import { computed, ref } from 'vue'

const props = defineProps({
  mobile: {
    type: String,
    default: ''
  },
  password: {
    type: String,
    default: ''
  },
  status: {
    type: String,
    default: 'idle'
  },
  errorMessage: {
    type: String,
    default: ''
  },
  signupSuccessMessage: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['submit', 'update:mobile', 'update:password', 'switch-mode', 'forgot-password'])

const showPassword = ref(false)

const busy = computed(() => props.status === 'logging_in')

const mobileDigits = computed(() => {
  const digits = String(props.mobile ?? '').replace(/\D/g, '')
  if (digits.startsWith('91') && digits.length >= 12) {
    return digits.slice(-10)
  }
  if (digits.startsWith('0') && digits.length === 11) {
    return digits.slice(1)
  }
  return digits.slice(-10)
})

const onMobileInput = (event) => {
  const digits = String(event.target.value ?? '').replace(/\D/g, '').slice(0, 10)
  emit('update:mobile', digits)
}

const onPasswordInput = (event) => {
  emit('update:password', event.target.value)
}

const handleSubmit = () => {
  emit('submit')
}
</script>

<style scoped>
.auth-step-text {
  color: #666;
  margin-bottom: 20px;
}

.password-wrapper {
  position: relative;
}

.password-wrapper input {
  padding-right: 40px;
}

.password-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  background: none;
  color: #888;
  cursor: pointer;
  padding: 0;
  font-size: 16px;
  line-height: 1;
}

.password-toggle:hover {
  color: #333;
}

.mobile-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-prefix {
  font-size: 16px;
  font-weight: 500;
  color: var(--title-color, #222);
  flex-shrink: 0;
  line-height: 56px;
}
</style>
